import React from "react";
import { motion } from "framer-motion";
// import { GraduationCap } from "lucide-react";

const Illustration: React.FC = () => {
  const lptkList = [
    "undiksha",
    "unesa",
    "um",
    "uny",
    "unnes",
    "unj",
    "upi",
    "unp",
    "unimed",
    "ung",
    "unima",
    "unm",
  ];

  // Orbit sedikit lebih besar dari versi sebelumnya
  const baseSize = 500;
  const radius = baseSize * 0.42; // sebelumnya 0.36

  return (
    <div className="relative w-full h-full flex items-center justify-center aspect-square">
      {/* Container berputar */}
      <motion.div
        className="absolute inset-0 flex items-center justify-center"
        animate={{ rotate: 360 }}
        transition={{ duration: 80, repeat: Infinity, ease: "linear" }}
        style={{
          transformOrigin: "center center",
          transformStyle: "preserve-3d",
          willChange: "transform",
        }}
      >
        {/* Orbit lingkaran */}
        <div
          className="absolute border border-blue-400/40 border-dashed rounded-full"
          style={{
            width: `${radius * 2}px`,
            height: `${radius * 2}px`,
          }}
        />

        {/* Logo-logo */}
        {lptkList.map((name, i) => {
          const angle = (i / lptkList.length) * 2 * Math.PI;
          const x = radius * Math.cos(angle);
          const y = radius * Math.sin(angle);
          return (
            <div
              key={i}
              className="absolute w-16 h-16 flex items-center justify-center"
              style={{
                transform: `translate(${x}px, ${y}px)`,
              }}
            >
              {/* Logo counter-rotate agar tetap tegak */}
              <motion.div
                animate={{ rotate: -360 }}
                transition={{ duration: 80, repeat: Infinity, ease: "linear" }}
                className="w-16 h-16 bg-white dark:bg-gray-800 rounded-full shadow-lg border border-gray-100 dark:border-gray-700 flex items-center justify-center"
              >
                <img
                  src={`/logo/logo_${name}.png`}
                  alt={name}
                  className="w-12 h-12 object-contain rounded-full select-none"
                  draggable="false"
                />
              </motion.div>
            </div>
          );
        })}
      </motion.div>

      {/* 🔵 Pusat diperbesar proporsional */}
      <div className="absolute w-96 h-96 md:w-[28rem] md:h-[28rem] bg-gradient-radial from-gray-100/70 to-transparent dark:from-gray-800/60 rounded-full flex items-center justify-center">
        <div className="w-64 h-64 bg-white dark:bg-gray-800/80 rounded-full flex items-center justify-center shadow-inner">
          {/* <GraduationCap className="w-28 h-28 text-gray-300 dark:text-gray-500" /> */}
          <img src={"/konaspi.png"} alt="Logo Konaspi" className="w-28 h-28 object-contain" />
        </div>
      </div>
    </div>
  );
};

export default Illustration;
